export const environment = {
  production: false,
  devBypassProtectedRoutes: true,
  apiBaseUrl: 'http://localhost:5001',
  apiVersion: 'v1.1',
  apiPrefix: 'api',
  adminApiSegment: 'admin',
  adminUsersPageSize: 10,
  adminCurrenciesPageSize: 10,
};
